import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M22.777 4.503a1 1 0 0 1 1.339-.07l.076.07 3.3 3.299.068.075c.32.393.298.973-.067 1.34l-2.067 2.068 1.537 1.537.064.079a.5.5 0 0 1-.064.629l-.708.707-.077.064a.502.502 0 0 1-.552 0l-.078-.064-1.535-1.537-13.04 13.063a.997.997 0 0 1-.483.267l-4.288.99-.135.022a1.002 1.002 0 0 1-1.087-1.088l.02-.133.99-4.29c.032-.136.092-.265.175-.377l.092-.105 13.04-13.062-1.527-1.529-.065-.078a.5.5 0 0 1 .065-.629l.707-.707a.5.5 0 0 1 .629-.064l.078.064 1.526 1.527 2.066-2.068ZM12.127 18l-4.252 4.26-.565 2.45 2.451-.565L15.895 18h-3.768Zm1.997-2h3.768l4.706-4.714-1.885-1.885-6.589 6.6Zm8.002-8.014 1.886 1.885 1.36-1.361-1.886-1.886-1.36 1.362Z" stroke="none"></path>';
export var ColorPickerOutlineSVG = function ColorPickerOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
ColorPickerOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(ColorPickerOutlineSVG);